if not App.angularApp?
    return

App.angularApp.directive 'mfClickAndDisable', () ->
    restrict: 'A',
    scope: {
        mfClickAndDisable: '&'
        alwaysReenable: '='
    }
    link: (scope, ele, attrs) ->
        ele.bind 'click', () =>
            # disable this input
            ele.prop('disabled', true)

            ###
            NOTE: To take full advantage of this directive
            call any operation that causes an ajax report last

            e.g. mf-click-and-disable="scope_var++; save();"
            ###

            # Call the passed in function(s)
            promise = scope.mfClickAndDisable()

            # If a valid promise was returned handle it
            promise?.then? (result) =>
                # re-enable if the request succeeded but returned an error,
                # e.g. if backend validation failed.
                if scope.alwaysReenable or not result? or
                        result?.data?.status?.type is 'error'
                    ele.prop('disabled', false)
            , () =>
                # re-enable if the request failed
                ele.prop('disabled', false)
